/**
 * Format date to a day string representation
 * @param date - input date to format
 */
export var formatDay = function formatDay(date) {
  return date.getDate().toString();
};